import { Component, Input } from '@angular/core';
import { ConstrainedField } from '@app/shared/models/constrained-field';
import { CdkDragDrop, transferArrayItem } from '@angular/cdk/drag-drop';
import { DragAndDropList } from '@shared/models/dnd';

@Component({
  selector: 'app-dnd-cell',
  templateUrl: './dnd-cell.component.html',
  styleUrls: ['./dnd-cell.component.scss'],
})
export class DndCellComponent {
  @Input() public field!: ConstrainedField;
  @Input() public dndList!: DragAndDropList;

  public drop(event: CdkDragDrop<any[]>): void {
    transferArrayItem(
      event.previousContainer.data,
      event.container.data,
      event.previousIndex,
      event.currentIndex,
    );

    this.field.control.setValue(this.dndList.selectedFields.map(selected => selected.id).join(','));
  }
}
